var React = require('react');

function Loading (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 24c-1.62 0-3.192-.316-4.671-.942a11.96 11.96 0 01-3.813-2.574 11.96 11.96 0 01-2.574-3.813A11.924 11.924 0 010 12a.843.843 0 111.688 0 10.297 10.297 0 003.021 7.294A10.26 10.26 0 0012 22.312a10.297 10.297 0 007.294-3.021A10.261 10.261 0 0022.312 12c0-1.392-.271-2.742-.81-4.015a10.324 10.324 0 00-2.21-3.279A10.258 10.258 0 0012 1.687.843.843 0 1112 0c1.62 0 3.192.316 4.671.942a11.96 11.96 0 013.813 2.574 11.98 11.98 0 012.571 3.813c.626 1.479.943 3.051.943 4.671s-.317 3.192-.943 4.671a11.917 11.917 0 01-2.57 3.813A11.981 11.981 0 0112 24z"}));
}

Loading.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Loading;

Loading.default = Loading;
